export enum AvailablePropertyType {
  BRAND = 'BRAND',
  MODEL = 'MODEL',
  REGISTRATION_PLATE = "REGISTRATION_PLATE",
  VIN = "VIN",
  NUMBER_AND_SERIES_REGISTRATION_CARD = "NUMBER_AND_SERIES_REGISTRATION_CARD",
  TECHNICAL_INSPECTION_DATE = "TECHNICAL_INSPECTION_DATE",
  INSURANCE_EXPIRY_DATE = "INSURANCE_EXPIRY_DATE",
  INSURANCE_POLICY = "INSURANCE_POLICY",
  UFG = "UFG",
  IDENTIFICATION_NUMBER = "IDENTIFICATION_NUMBER",
  FACTORY_NUMBER = "FACTORY_NUMBER",
  MILEAGE = "MILEAGE",
  MOTO_HOURS = "MOTO_HOURS",
  ANNOTATIONS = "ANNOTATIONS",
  TACHOGRAPH_INSPECTION_DATE = 'TACHOGRAPH_INSPECTION_DATE',
  UNKNOWN = "UNKNOWN"
}
